export const MOBILE_INPUT_STATE = 'mobile-input';
export const MOBILE_VERIFICATION_STATE = 'mobile-verification';
export const EMAIL_INPUT_STATE = 'email-input';
export const EMAIL_VERIFICATION_STATE = 'email-verification';

export const MOBILE_MODE = 'mobile';
export const EMAIL_MODE = 'email';
